import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const CloneWorkflowLengthyRequestAlert = () => {
  return /*#__PURE__*/_jsx(UIAlert, {
    className: "m-bottom-5",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.CloneWorkflowLengthyRequestAlert.title"
    }),
    type: "info",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-management.CloneWorkflowLengthyRequestAlert.body"
    })
  });
};
export default CloneWorkflowLengthyRequestAlert;